import React, { Fragment, memo, useEffect, useState } from 'react';
import cn from 'classnames';
import styles from './index.module.scss';
import { ITab, ITabList } from '../../store';
import { HeroCardBlock } from '../..';
import { colorBlack } from '~/common/utils';

const TabHeader = (props: ITab) => {
  const { idx, fontColor, header, setActive, active } = props;
  return (
    <div
      style={{
        color: `#${fontColor || colorBlack}`,
      }}
      className={cn(styles.TabHeader, { [styles.Active]: active })}
      onClick={() => idx && setActive && setActive(idx)}
    >
      <span
        dangerouslySetInnerHTML={{
          __html: header as string,
        }}
      />
    </div>
  );
};

const TabContent = (props: ITab) => {
  const { content, active } = props;
  const [expand, setExpand] = useState(active);

  useEffect(() => setExpand(active), [active]);
  return (
    <div className={cn(styles.TabContent)}>
      {expand && content && (
        <HeroCardBlock areas={content} _gridColumnCount={12} />
      )}
    </div>
  );
};

const HeroCardTabList = memo((props: ITabList) => {
  const { items, vertical, alignment } = props;
  const [activeIdx, setActiveIdx] = useState(1);

  return (
    <div
      className={cn(styles.HeroCardTabList, { [styles.Vertical]: vertical })}
    >
      <div
        className={styles.TabHeaderList}
        style={{
          justifyContent: alignment ?? (vertical ? 'start' : 'center'),
        }}
      >
        {items &&
          items.length > 0 &&
          items.map((item, idx) => (
            <Fragment key={idx}>
              <TabHeader
                {...{
                  ...(item as ITab),
                  idx: idx + 1,
                  active: activeIdx === idx + 1,
                  setActive: () => setActiveIdx(idx + 1),
                }}
              />
            </Fragment>
          ))}
      </div>

      <div className={styles.TabContentList}>
        {items &&
          items.length > 0 &&
          items.map((item, idx) => (
            <Fragment key={idx}>
              <TabContent
                {...{
                  ...(item as ITab),
                  idx: idx + 1,
                  active: activeIdx === idx + 1,
                  setActive: () => setActiveIdx(idx + 1),
                }}
              />
            </Fragment>
          ))}
      </div>
    </div>
  );
});

export default HeroCardTabList;
